// extracted by mini-css-extract-plugin
export default {"dimensionsFilterDropdownContainer":"DimensionsFilterDropdown_dimensionsFilterDropdownContainer__KpQPq","select":"DimensionsFilterDropdown_select__SusFS"};